import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ArrowLeft } from 'lucide-react';
export function IntegrationFlow() {
  return <section className="py-20 bg-slate-50" data-id="element-310">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-311">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 sm:mb-12" data-id="element-312">
          <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-4" data-id="element-313">
            Integration Flow
          </h2>
          <p className="text-base sm:text-lg text-slate-600" data-id="element-314">
            End-to-end request and response flow through Obseq infrastructure.
          </p>
        </motion.div>

        <div className="max-w-5xl mx-auto" data-id="element-315">
          {/* Flow Diagram */}
          <div className="bg-white rounded-xl border border-slate-200 p-8 lg:p-12" data-id="element-316">
            {/* Forward Flow */}
            <div className="flex flex-col lg:flex-row items-center justify-between gap-4 mb-8" data-id="element-317">
              {['Client App', 'Obseq API', 'Products', 'Rails'].map((step, i) => <Fragment key={i} data-id="element-318">
                    <motion.div initial={{
                opacity: 0,
                scale: 0.9
              }} whileInView={{
                opacity: 1,
                scale: 1
              }} viewport={{
                once: true
              }} transition={{
                delay: i * 0.1
              }} className={`${i === 1 ? 'bg-blue-600 text-white' : 'bg-slate-50 border-2 border-slate-200 text-slate-900'} rounded-lg p-6 text-center flex-1 w-full lg:w-auto min-w-[140px]`} data-id="element-319">
                      <span className="text-sm font-semibold" data-id="element-320">{step}</span>
                    </motion.div>
                    {i < 3 && <ArrowRight className="w-6 h-6 text-slate-400 hidden lg:block flex-shrink-0" data-id="element-321" />}
                  </Fragment>)}
            </div>

            {/* Products Layer */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.5
          }} className="mb-8" data-id="element-322">
              <div className="text-center mb-4" data-id="element-323">
                <span className="text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-324">
                  Product Layer
                </span>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-2" data-id="element-325">
                {['Orchestrate', 'Payments', 'Wallets', 'Exchange', 'Compliance', 'Liquidity', 'Tokenize', 'Connect'].map((product, i) => <div key={i} className="bg-slate-100 border border-slate-200 rounded p-2 text-center" data-id="element-326">
                    <span className="text-xs font-medium text-slate-700" data-id="element-327">
                      {product}
                    </span>
                  </div>)}
              </div>
            </motion.div>

            {/* Return Flow */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.7
          }} data-id="element-328">
              <div className="flex items-center justify-center gap-3 mb-4" data-id="element-329">
                <ArrowLeft className="w-5 h-5 text-green-600" data-id="element-330" />
                <span className="text-sm font-semibold text-green-700" data-id="element-331">
                  Webhooks
                </span>
                <ArrowLeft className="w-5 h-5 text-green-600" data-id="element-332" />
              </div>
              <div className="bg-green-50 border border-green-200 rounded-lg p-4 text-center" data-id="element-333">
                <span className="text-sm font-medium text-green-700" data-id="element-334">
                  Real-time event notifications return to Client App
                </span>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}